// extracted by mini-css-extract-plugin
export default {"InputIcon":"TextInput_InputIcon__Ny+ad","labelMargin":"TextInput_labelMargin__QHbyR","InputStyle":"TextInput_InputStyle__h2EvC"};